import React from 'react';

const Stats = ({
  stats,
  showTotalValue,
  total
}) => {
  if (showTotalValue) {
    stats = [{
      label: 'Total',
      stat: total
    }, ...stats];
  }

  return stats.map(stat => {
    return /*#__PURE__*/React.createElement("div", {
      key: stat.label,
      className: "chart__stat"
    }, /*#__PURE__*/React.createElement("span", null, stat.label, ":"), /*#__PURE__*/React.createElement("span", null, stat.stat));
  });
};

export default Stats;